namespace TabAurous.Common {
    export namespace FormatHelperService {
        export const baseUrl = 'Common/FormatHelper';


        export declare const enum Methods {

        }

    }
}
